import React from 'react'
import ErrorPage from '../../components/ErrorPage'

const Error404 = () => (
  <ErrorPage
    statusCode={404}
    icon="search"
    title="ページが見つかりません"
    action="受け取った編集リンクを、もう一度そのまま開いてください。"
  />
)

export default Error404
